import { syncIconCardStackOffset } from "../shared/icon-card-offset.js";

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".icon-cards-to-sliders-left-icon");

  sections.forEach((section) => {
    const wrappers = section.querySelectorAll(".inner-wrapper");
    const iconImages = section.querySelectorAll(".icon-area img");

    if (!wrappers.length) return;

    let layoutSyncFrame = null;

    function syncLayout() {
      syncIconCardStackOffset(section, wrappers, {
        uniformHeightProperty: "--icon-card-uniform-height",
        offsetProperty: "--icon-card-icon-offset",
        stackSelector: ".card-content",
      });
    }

    function scheduleLayoutSync() {
      if (layoutSyncFrame) {
        cancelAnimationFrame(layoutSyncFrame);
      }

      layoutSyncFrame = requestAnimationFrame(() => {
        syncLayout();
        layoutSyncFrame = null;
      });
    }

    iconImages.forEach((image) => {
      if (image.complete) return;

      image.addEventListener("load", scheduleLayoutSync, { once: true });
    });

    scheduleLayoutSync();
    window.addEventListener("load", scheduleLayoutSync);
    window.addEventListener("resize", scheduleLayoutSync);
  });
});
